import { render } from "./SingleTeamView.vue?vue&type=template&id=31b9c6da"
import script from "./SingleTeamView.vue?vue&type=script&lang=js"
export * from "./SingleTeamView.vue?vue&type=script&lang=js"

import "./SingleTeamView.vue?vue&type=style&index=0&id=31b9c6da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__